(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const seen = new WeakSet();
  const animations = new Set();
  const ease = 'cubic-bezier(.16,1,.3,1)';
  function play(node, frames, options) {
    if(reduce.matches || !node.animate) return;
    const animation=node.animate(frames,options);animations.add(animation);
    animation.finished.catch(()=>{}).finally(()=>animations.delete(animation));
  }
  function revealText(el) {
    // Native theme animations own all split-lines / reveal-on-scroll headings.
    if (el.querySelector('split-lines') || el.hasAttribute('reveal-on-scroll') || el.closest('slideshow-carousel')) return;
    if(el.children.length){play(el,[{clipPath:'inset(0 0 100% 0)',transform:'translateY(12px)'},{clipPath:'inset(0 0 -10% 0)',transform:'translateY(0)'}],{duration:950,easing:ease});return;}
    const text=el.textContent.trim();if(!text)return;
    const fragment=document.createDocumentFragment();
    const accessible=document.createElement('span');accessible.className='sr-only';accessible.textContent=text;fragment.append(accessible);
    text.split(/\s+/).forEach((word,i)=>{if(i)fragment.append(document.createTextNode(' '));const mask=document.createElement('span');mask.className='senza-word-mask';mask.setAttribute('aria-hidden','true');const inner=document.createElement('span');inner.className='senza-word';inner.textContent=word;mask.append(inner);fragment.append(mask)});
    el.replaceChildren(fragment);
    let line=-1,top=-100;el.querySelectorAll('.senza-word-mask').forEach(mask=>{const y=mask.offsetTop;if(Math.abs(y-top)>4){line++;top=y}play(mask.firstChild,[{transform:'translateY(108%)'},{transform:'translateY(0)'}],{duration:mobile.matches?850:1100,delay:Math.min(line*110,330),easing:ease});});
  }
  const observer = 'IntersectionObserver' in window
  ? new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      observer.unobserve(entry.target);
      if (reduce.matches) return;

      if (entry.target.matches('.sf-photo')) {
        play(
          entry.target,
          [
            { clipPath: 'inset(0 0 100% 0)' },
            { clipPath: 'inset(0 0 0 0)' }
          ],
          { duration: 1200, easing: ease }
        );

        const img = entry.target.querySelector('img');

        if (img) {
          play(
            img,
            [
              { transform: 'scale(1.075)' },
              { transform: 'scale(1)' }
            ],
            { duration: 1600, easing: ease }
          );
        }
      } else {
        revealText(entry.target);
      }
    }), { threshold: 0.08 })
  : null;

function init(scope = document) {
  scope.querySelectorAll(
    '[data-senza-reveal], .sz-heading, .image-marquee-wrapper h2, .shopify-section--rich-text .prose > .h1, .shopify-section--rich-text .prose > .h2, .sf-photo'
  ).forEach(el => {
    if (seen.has(el)) return;
    seen.add(el);
    observer?.observe(el);
  });

  scope.querySelectorAll('[data-senza-footer]').forEach(footer => {
    if (footer.dataset.initialized) return;
    footer.dataset.initialized = 'true';

    const controller = new AbortController();
    const signal = controller.signal;
    const shell = footer.closest('#senza-footer-shell');

    const accordion = () => {
      footer.querySelectorAll('details').forEach(detail => {
        detail.open = !mobile.matches;
      });
    };

    // Cortina adaptable a desktop, mobile y footers altos.
    function curtain() {
      const viewport = window.innerHeight;

      const enabled =
  !!shell &&
  footer.dataset.curtain === 'true' &&
  !reduce.matches &&
  document.querySelector('#main')?.offsetHeight > viewport;

      if (shell) {
        shell.style.setProperty(
          '--sz-curtain-bottom',
          `${Math.min(0, viewport - shell.offsetHeight)}px`
        );
      }

      document.body.classList.toggle('sz-curtain-active', !!enabled);
    }

    const gallery = footer.querySelector('.sf-gallery');
    const controls = footer.querySelector('.sf-controls');

    function progress() {
      if (!gallery || !controls) return;

      const max = gallery.scrollWidth - gallery.clientWidth;
      controls.hidden = max < 2;

      const ratio = max > 0
        ? Math.min(1, Math.max(0, gallery.scrollLeft / max))
        : 1;

      const fraction = gallery.scrollWidth > 0
        ? gallery.clientWidth / gallery.scrollWidth
        : 1;

      controls.querySelector('i').style.width =
        `${100 * (fraction + (1 - fraction) * ratio)}%`;

      controls.querySelector('[data-sf-prev]').disabled =
        gallery.scrollLeft < 2;

      controls.querySelector('[data-sf-next]').disabled =
        max < 2 || gallery.scrollLeft >= max - 2;
    }

    footer.addEventListener('click', e => {
      const button = e.target.closest('button');
      if (!button) return;

      if (button.hasAttribute('data-sf-top')) {
        window.scrollTo({
          top: 0,
          behavior: reduce.matches ? 'instant' : 'smooth'
        });
      }

      if (
        gallery &&
        (
          button.hasAttribute('data-sf-prev') ||
          button.hasAttribute('data-sf-next')
        )
      ) {
        const direction = button.hasAttribute('data-sf-prev') ? -1 : 1;
        const photo = gallery.querySelector('.sf-photo');
        const gap = parseFloat(getComputedStyle(gallery).columnGap) || 0;
        const step = photo
          ? photo.getBoundingClientRect().width + gap
          : gallery.clientWidth;

        gallery.scrollBy({
          left: direction * step,
          behavior: reduce.matches ? 'instant' : 'smooth'
        });
      }
    }, { signal });

    gallery?.addEventListener('scroll', progress, {
      passive: true,
      signal
    });

    mobile.addEventListener('change', () => {
      accordion();
      curtain();
      progress();
    }, { signal });

    window.addEventListener('resize', curtain, {
      passive: true,
      signal
    });

    reduce.addEventListener('change', curtain, { signal });

    const resize = 'ResizeObserver' in window
      ? new ResizeObserver(() => {
          curtain();
          progress();
        })
      : null;

    resize?.observe(footer);
    if (gallery) resize?.observe(gallery);

    document.addEventListener('shopify:section:unload', e => {
      if (e.target.contains(footer)) {
        controller.abort();
        resize?.disconnect();
        document.body.classList.remove('sz-curtain-active');
        shell?.style.removeProperty('--sz-curtain-bottom');
      }
    }, { signal });

    accordion();
    progress();
    curtain();
  });
}
  reduce.addEventListener('change',()=>{if(reduce.matches)animations.forEach(a=>a.finish())});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
})();
